<template>
  <div class="rencai">
    <div class="select">
      <el-select popper-class="elselect" v-model="value" placeholder="请选择" @change="SelectChange">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <ul class="boxs">
      <li v-for="item in resumeListIos" :key="item.id" data-wow-duration="1s">
        <div class="title">
          <div class="zhiwei">{{item.zhiwei}}</div>
          <div class="xueli">{{item.xueli}}</div>
        </div>
        <div class="content">
          <div class="content-box">
            <h4>职位描述：</h4>
            <p v-for="(item2,index) in item.miaoshu" :key="index">
              {{item2}}
            </p>
          </div>
          <div class="content-box">
            <h4>任职资格：</h4>
            <p v-for="(item3,index) in item.zege" :key="index">
              {{item3}}
            </p>
          </div>
        </div>
        <div class="email">简历投递：lijuan@gytcare.com</div>
      </li>

    </ul>
  </div>
</template>

<script>
import resumeList from "../../assets/js/resumeList";
export default {
  data() {
    return {
      resumeList,
      resumeListIos: resumeList,
      options: [{
        value: '1',
        label: '血透医生'
      }, {
        value: '2',
        label: '透析室护士'
      }, {
        value: '3',
        label: 'python开发工程师'
      }, {
        value: '4',
        label: '产品经理'
      }, {
        value: '5',
        label: '售前工程师'
      }],
      value: '1'
    }
  },
  created() {
    if (document.body.clientWidth < 540) {
      this.SelectChange()
    }
  },
  mounted() {

  },
  methods: {
    SelectChange() {
      this.resumeListIos = this.resumeList.filter(item => {
        return item.id == this.value
      })
    }
  }
}
</script>

<style scoped lang="scss">
.rencai {
  padding: 1.0526rem 0;
  .select {
    display: none;
    @media screen and (max-width: 540px) {
      display: block;
    }
    padding: 15px;
    .el-select {
      width: 100%;
      height: 55px;
      background-color: #f8f8f8;
      /deep/ input {
        height: 55px;
      }
      span {
        padding: 0 20px;
        color: #0ca6eb;
        font-size: 15px;
      }
      font-size: 14px;
      color: #666666;
    }
  }
  ul {
    overflow: hidden;
    padding: 0 1.4526rem;
    @media screen and (max-width: 540px) {
      padding: 0 15px;
    }
    li {
      float: left;
      width: 8.2105rem;
      @media screen and (max-width: 540px) {
        width: 100%;
        height: 100%;
      }
      height: 9.0526rem;
      overflow: hidden;
      position: relative;
      background-color: #f8f8f8;
      margin: 0 0.1053rem;
      margin-bottom: 0.3579rem;
      .title {
        display: flex;
        height: 1.0947rem;
        align-items: center;
        border-bottom: 1px solid #e0e0e0;
        @media screen and (max-width: 540px) {
          padding: 10px 0;
        }
        .zhiwei {
          padding: 0 0.7368rem 0 0.4rem;
          color: #0ca6eb;
          font-weight: 700;
          font-size: 0.2737rem;
          @media screen and (max-width: 540px) {
            font-size: 15px;
          }
        }
        .xueli {
          font-size: 0.2421rem;
          color: #666666;
          @media screen and (max-width: 540px) {
            font-size: 12px;
          }
        }
      }
      .content {
        padding: 0.4316rem 0.2632rem 0 0.3895rem;
        @media screen and (max-width: 540px) {
          padding: 10px;
        }
        .content-box {
          padding-bottom: 0.4421rem;
          @media screen and (max-width: 540px) {
            padding-bottom: 20px;
          }
          h4 {
            color: #333333;
            font-size: 0.2316rem;
            margin: 0;
            margin-bottom: 0.1579rem;
            @media screen and (max-width: 540px) {
              font-size: 12px;
            }
          }
          p {
            font-size: 0.1895rem;
            color: #666666;
            line-height: 0.3368rem;
            @media screen and (max-width: 540px) {
              line-height: 26px;
              font-size: 12px;
            }
          }
        }
      }
      .email {
        position: absolute;
        right: 0.4947rem;
        bottom: 0.4947rem;
        font-size: 0.2526rem;
        color: #334046;
        @media screen and (max-width: 540px) {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
